import { CONFIG } from '@frameio/config';

export const getV3Url = (accountId?: string) => {
  const url = CONFIG.appServerOrigin
    .replace('next', 'app')
    .replace('local', 'app');

  return `${url}${accountId ? `/accounts/${accountId}` : ''}`;
};

export const redirectToV3 = (accountId?: string) => {
  window.location.assign(getV3Url(accountId));
};
